import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { globals } from 'src/app/globals';
import { ToastService } from '../../services/toast.service';
import { userService } from '../../services/user.service';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.page.html',
  styleUrls: ['./teams.page.scss'],
})
export class TeamsPage implements OnInit {

  user: any = {};
  state: any = 1;
  teams: any = {};
  build: any = {};
  team: any = {};
  search: any = {};
  users: any = {};
  allUsers: any = {};

  constructor(
    public userService: userService,
    private router: Router,
    private toastService: ToastService,
    private http: HttpClient
  ) { }

  create() {
    this.state = 2;
  }
  back() {
    this.state = 1;
    this.getTeams();
  }

  getTeams() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getTeams')

    const body = {
      cid: this.user.cid,
      sid: this.user.sid,
      id: this.user.id,
      query: this.search.query
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.teams = response.body.dataArray;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, no results found' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, no results found' });
        }
      );
    
  }

  getUsers() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getUsers')

    const body = {
      id: this.user.id,
      sid: this.user.sid
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.allUsers = response.body.dataArray;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting users' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting users' });
        }
      );
    
  }
  
  selectTeam(team: any) {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getUsers')

    const body = {
      id: this.user.id,
      team: team
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            for (const value of response.body.dataArray) {
              value.photoUrl = this.build.cdn + value.photo;
            }

            this.users = response.body.dataArray;
          }
          else {
            this.users = {};
          }
          this.team = team;
          this.state = 2;
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting user data' });
        }
      );
  }

  createUser() {
    this.state = 4;
  }

  refresh(event: any) {
    this.teams = {};
    this.getTeams();
    setTimeout(() => {
      event.target.complete();
    }, 500);
  }

  addUserToTeam() {
    this.state = 5;
  }

  confirmUserToTeam(x: any) {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'addUserToTeam')

    const body = {
      id: this.user.id,
      team: this.team,
      user: x.id
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            this.users = response.body.dataArray;
            this.state = 2;
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong adding team member' });
        }
      );

  }

  returnZero() {
    return 0
  }

  ngOnInit() {
    this.user = this.userService.getData();
    this.build = globals;
    this.getTeams();
    this.getUsers();
  }

}